import { defaultParserRegistry, parseCSV as parseCSVWithRegistry } from './ParserRegistry.js';

/**
 * Generic CSV Parser
 * Automatically detects format and parses transactions from various banks
 * Now uses the ParserRegistry for extensible parser management
 *
 * @param {string} csvText - The CSV file content
 * @param {string} filename - Full path like "Chase/John/file.csv" or "Amex/Shelly/file.csv"
 * @param {string} bankHint - Optional bank name hint from folder structure
 */
export function parseCSV(csvText, filename, bankHint = null) {
  // Use the default registry for parsing
  return parseCSVWithRegistry(defaultParserRegistry, csvText, filename, bankHint);
}
